import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../utils/api';

// Query keys
const WHAT_WE_ARE_QUERY_KEY = 'whatWeAre';

// Custom hook for fetching what we are data
export const useWhatWeAre = () => {
  return useQuery({
    queryKey: [WHAT_WE_ARE_QUERY_KEY],
    queryFn: () => apiClient.whatWeAre.get(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Custom hook for creating what we are data
export const useCreateWhatWeAre = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data) => apiClient.whatWeAre.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [WHAT_WE_ARE_QUERY_KEY] });
    },
  });
};

// Custom hook for updating what we are data
export const useUpdateWhatWeAre = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data) => apiClient.whatWeAre.update(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [WHAT_WE_ARE_QUERY_KEY] });
    },
  });
};

// Custom hook for deleting what we are data
export const useDeleteWhatWeAre = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (id) => apiClient.whatWeAre.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [WHAT_WE_ARE_QUERY_KEY] });
    },
  });
}; 